const DESIGN_RUSH_LINK = 'https://www.designrush.com/agency/profile/modsen'
const GOOD_FIRMS_LINK = 'https://www.goodfirms.co/company/modsen'
const TOPDEVELOPERS_LINK = 'https://www.topdevelopers.co/profile/modsen'
const SUPERB_COMPANIES_LINK =
  'https://superbcompanies.com/organizations/modsen/'

const GOOD_FIRMS_TITLE = 'GoodFirms'
const DESIGN_RUSH_TITLE = 'DESIGNRUSH'
const TOPDEVELOPERS_TITLE = 'TopDevelopers'
const SUPERB_COMPANIES_TITLE = 'SuperbCompanies'

const TOPDEVELOPERS_SOFTWARE_SRC = '/images/top-software-developers.webp'

export const config = {
  allRatings: [
    {
      id: 'businessfirms',
      src: '/images/medtech-business-firms.webp',
      title: 'Business Firms',
      path: 'https://businessfirms.co/company/modsen',
    },
    {
      id: 'itrate',
      src: '/images/itrate.webp',
      title: 'iTRate',
      path: 'https://itrate.co/developers/all/pl',
    },
    {
      id: 'goodfirms-development',
      src: '/images/top-goodfirms.webp',
      title: GOOD_FIRMS_TITLE,
      path: GOOD_FIRMS_LINK,
    },
    {
      id: 'goodfirms',
      src: '/images/top-good-firms.webp',
      title: GOOD_FIRMS_TITLE,
      path: GOOD_FIRMS_LINK,
    },
    {
      id: 'goodfirms-fintech',
      src: '/images/goodfirms-fintech.webp',
      title: GOOD_FIRMS_TITLE,
      path: GOOD_FIRMS_LINK,
    },
    {
      id: 'goodfirms-business',
      src: '/images/top-business-services-company.webp',
      title: GOOD_FIRMS_TITLE,
      path: GOOD_FIRMS_LINK,
    },
    {
      id: 'goodfirms-medtech',
      src: '/images/medtech-telemedicine-software.webp',
      title: GOOD_FIRMS_TITLE,
      path: GOOD_FIRMS_LINK,
    },
    {
      id: 'goodfirms-social-media',
      src: '/images/goodfirms-social-media.webp',
      title: GOOD_FIRMS_TITLE,
      path: GOOD_FIRMS_LINK,
    },
    {
      id: 'goodfirms-logistics',
      src: '/images/top-logistics-goodfirm.webp',
      title: GOOD_FIRMS_TITLE,
      path: GOOD_FIRMS_LINK,
    },
    {
      id: 'goodfirms-iot',
      src: '/images/top-iot-goodfirms.webp',
      title: GOOD_FIRMS_TITLE,
      path: GOOD_FIRMS_LINK,
    },
    {
      id: 'goodfirms-mobile',
      src: '/images/top-mobile-goodfirms.webp',
      title: GOOD_FIRMS_TITLE,
      path: GOOD_FIRMS_LINK,
    },
    {
      id: 'goodfirms-ios',
      src: '/images/top-ios-goodfirms.webp',
      title: GOOD_FIRMS_TITLE,
      path: GOOD_FIRMS_LINK,
    },
    {
      id: 'goodfirms-software-dev',
      src: '/images/top-android-goodfirms.webp',
      title: GOOD_FIRMS_TITLE,
      path: GOOD_FIRMS_LINK,
    },
    {
      id: 'goodfirms-web',
      src: '/images/goodfirms-web.webp',
      title: GOOD_FIRMS_TITLE,
      path: GOOD_FIRMS_LINK,
    },
    {
      id: 'goodfirms-design',
      src: '/images/designrush-web-design-software.webp',
      title: GOOD_FIRMS_TITLE,
      path: GOOD_FIRMS_LINK,
    },
    {
      id: 'goodfirms-devops',
      src: '/images/goodfirms-devops.webp',
      title: GOOD_FIRMS_TITLE,
      path: GOOD_FIRMS_LINK,
    },
    {
      id: 'goodfirms-cloud',
      src: '/images/top-cloud-goodfirms.webp',
      title: GOOD_FIRMS_TITLE,
      path: GOOD_FIRMS_LINK,
    },
    {
      id: 'todevelopers-mobile-app',
      src: '/images/top-software-developers-travel.webp',
      title: TOPDEVELOPERS_TITLE,
      path: TOPDEVELOPERS_LINK,
    },
    {
      id: 'todevelopers-software',
      src: TOPDEVELOPERS_SOFTWARE_SRC,
      title: TOPDEVELOPERS_TITLE,
      path: TOPDEVELOPERS_LINK,
    },
    {
      id: 'todevelopers-logistics',
      src: TOPDEVELOPERS_SOFTWARE_SRC,
      title: TOPDEVELOPERS_TITLE,
      path: 'https://www.topdevelopers.co/directory/logistics-app-development-companies?country=poland&page=1',
    },
    {
      id: 'todevelopers-wed-dev',
      src: '/images/top-web-development-companies.webp',
      title: TOPDEVELOPERS_TITLE,
      path: 'https://www.topdevelopers.co/directory/logistics-app-development-companies?country=poland&page=1',
    },
    {
      id: 'todevelopers-top-ux',
      src: '/images/medtech-designing-companies.webp',
      title: TOPDEVELOPERS_TITLE,
      path: TOPDEVELOPERS_LINK,
    },
    {
      id: 'todevelopers-big-data',
      src: '/images/top-big-data-companies.webp',
      title: TOPDEVELOPERS_TITLE,
      path: TOPDEVELOPERS_LINK,
    },
    {
      id: 'todevelopers-ios',
      src: '/images/top-ios-developers.webp',
      title: TOPDEVELOPERS_TITLE,
      path: TOPDEVELOPERS_LINK,
    },
    {
      id: 'todevelopers-android',
      src: '/images/top-android-developers.webp',
      title: TOPDEVELOPERS_TITLE,
      path: TOPDEVELOPERS_LINK,
    },
    {
      id: 'todevelopers-cloud',
      src: '/images/top-cloud-developers.webp',
      title: TOPDEVELOPERS_TITLE,
      path: 'https://www.topdevelopers.co/directory/cloud-computing-service-providers?country=poland&page=1',
    },
    {
      id: 'designrush',
      src: '/images/designrush.webp',
      title: DESIGN_RUSH_TITLE,
      path: DESIGN_RUSH_LINK,
    },
    {
      id: 'designrush-top-ux',
      src: '/images/designrush-travel.webp',
      title: DESIGN_RUSH_TITLE,
      path: DESIGN_RUSH_LINK,
    },
    {
      id: 'designrush-fintech',
      src: '/images/designrush-fintech.webp',
      title: DESIGN_RUSH_TITLE,
      path: 'https://www.designrush.com/agency/software-development/fintech',
    },
    {
      id: 'designrush-mobile',
      src: '/images/designrush-top-mobile.webp',
      title: DESIGN_RUSH_TITLE,
      path: DESIGN_RUSH_LINK,
    },
    {
      id: 'designrush-android',
      src: '/images/designrush-top-android-app.webp',
      title: DESIGN_RUSH_TITLE,
      path: DESIGN_RUSH_LINK,
    },
    {
      id: 'designrush-web-design',
      src: '/images/designrush-top-web-design-companies.webp',
      title: DESIGN_RUSH_TITLE,
      path: DESIGN_RUSH_LINK,
    },
    {
      id: 'designrush-iphone',
      src: '/images/designrush-iphone.webp',
      title: DESIGN_RUSH_TITLE,
      path: DESIGN_RUSH_LINK,
    },
    {
      id: 'designrush-outsourcing',
      src: '/images/designrush-top-outsourcing.webp',
      title: DESIGN_RUSH_TITLE,
      path: DESIGN_RUSH_LINK,
    },
    {
      id: 'designrush-staff',
      src: '/images/designrush-top-staff.webp',
      title: DESIGN_RUSH_TITLE,
      path: 'https://www.designrush.com/agency/software-development/fintech',
    },
    {
      id: 'techreviewer',
      src: '/images/techReviewer-travel.webp',
      title: 'Techreviewer',
      path: 'https://techreviewer.co/companies/modsen',
    },
    {
      id: 'wealth-finance',
      src: '/images/wealth_finance.webp',
      title: 'Wealth&Finance',
      path: 'https://www.wealthandfinance-news.com/winners/modsen/',
    },
    {
      id: 'supercompanies',
      src: '/images/superbcompanies.webp',
      title: SUPERB_COMPANIES_TITLE,
      path: SUPERB_COMPANIES_LINK,
    },
    {
      id: 'supercompanies-top',
      src: '/images/top-super-companies.webp',
      title: SUPERB_COMPANIES_TITLE,
      path: SUPERB_COMPANIES_LINK,
    },
    {
      id: 'clutch',
      src: '/images/partnership/certificates/clutch.svg',
      title: 'Clutch',
    },
    {
      id: 'selectedFirms',
      src: '/images/selectedFirms.svg',
      title: 'SelectedFirms',
    },
  ],
}
